export const PROPERTY_TYPE_OPTIONS = [
  'apartment',
  'garsoniere',
  'villa',
  'office',
  'magazine',
  'shop',
  'parkim',
  'land',
];

export const PROPERTY_TYPES_WITHOUT_BEDROOMS = [
  'garsoniere',
  'land',
  'office',
  'parkim',
  'magazine',
  'shop',
];

export const isBedroomsOptional = (propertyType) =>
  PROPERTY_TYPES_WITHOUT_BEDROOMS.includes(propertyType);
